<template>
  <div class="register">
    <div class="project">
      <img class="project-logo" :src="projectLogo" />
      <p class="project-text">{{projectName}}</p>
    </div>
    <div class="content">
      <div class="main">
        <el-form label-width="70px">
          <div v-for="(item,index) in items" :key="index">
            <el-form-item>
              <span slot="label" class="label-text">{{item.label}}</span>
              <div class="code-wrapper">
                <el-input v-model="item.inputValue" :placeholder="item.placeholder"></el-input>
                <el-button v-if="index===items.length-1" class="code-button" type="primary">获取验证码</el-button>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div class="button-wrapper">
          <el-button class="button" type="primary" @click="registerButtonClick" >免费注册</el-button>
          <p class="login-tips">已经有账号？点此
            <el-button type="text" class="login-tips-text" @click="loginTextClick">登录</el-button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    projectName: {
      type: String
    },
    projectLogo: {
      type: String
    },
    items: {
      type: Array,
      default: () => [
        {
          label: '用户名',
          inputValue: '',
          placeholder: '请输入用户名'
        },
        {
          label: '密码',
          inputValue: '',
          placeholder: '请输入密码'
        },
        {
          label: '确认密码',
          inputValue: '',
          placeholder: '请输入确认密码'
        },
        {
          label: '手机号码',
          inputValue: '',
          placeholder: '请输入手机号码'
        },
        {
          label: '验证码',
          inputValue: '',
          placeholder: '请输入验证码'
        }
      ]
    }
  },
  data () {
    return {}
  },
  methods: {
    registerButtonClick () {
      this.$emit('registerButtonClick')
    },
    loginTextClick () {
      this.$emit('loginTextClick')
    }
  }
}
</script>
<style lang="less" scoped>
.register {
  width: 400px;
  padding: 20px;
  box-sizing: border-box;
    background-color: #304156;
  .project {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .project-logo {
      width: 42px;
      height: 42px;
    }
    .project-text {
      margin-left: 10px;
      font-size: 28px;
      color: #fff;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .main {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 330px;
      .label-text {
        color: #ffffff;
      }
      .code-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;
        .code-button {
          margin-left: 10px;
          background-color: #103a5e;
        }
      }
      .button-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        // justify-content: center;
        // align-items: center;
        margin-top: 10px;
        .button{
          // 330-70
          width: 260px;
        }
        .login-tips {
          font-size: 14px;
          margin-top: 10px;
          color: #ffffff;
          // .login-tips-text {
          //   color: #5ec4ff;
          // }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// third_party/common_app/LoginModule/View/Ctrl/RegisterCtrl.vue